import {FormItemProps} from "@/components/Form/types";
import {ENVIRONMENT_MAPS, NEW_PROFILE_ENVIRONMENT} from "@/shared/productViewer";





const defaultEnvironment = ENVIRONMENT_MAPS.find((e) => e.file === NEW_PROFILE_ENVIRONMENT)

const Items: Array<FormItemProps> = [

    {
        name: 'environmentMap',
        label: 'Environment',
        help:
            'The lighting environment the product is rendered in. "Highlights" is what makes ' +
            'engraved text, knurling and machined edges readable — a flat environment lights ' +
            'the product evenly and those details disappear, however high the exposure.',
        placeholder: 'Environment',
        type: 'Select',
        defaultValue: defaultEnvironment
            ? {value: defaultEnvironment.file, label: defaultEnvironment.label}
            : undefined,
        itemOptions: {
            list: ENVIRONMENT_MAPS.map((e) => ({value: e.file, label: e.label})),
        },
        classNames: {container: 'col-span-12 '},
    },
    {
        name: 'toneMappingExposure',
        label: 'Exposure',
        help: 'Adjust the overall brightness of the rendered 3D product preview.',
        placeholder: 'Exposure',
        type: 'Range',
        defaultValue: 1,
        itemOptions: {
            min: 0,
            step: 0.01,
            max: 5
        },
        classNames: {container: 'col-span-12 '},
    },
    {
        name: 'keyLightIntensity',
        label: 'Key Light',
        help: 'Adjust the intensity of the primary light used to define the product shape in the 3D preview.',
        placeholder: 'Key Light',
        type: 'Range',
        defaultValue: 0.05,
        itemOptions: {
            min: 0,
            step: 0.05,
            max: 5
        },
        classNames: {container: 'col-span-12 '},
    },
    {
        name: 'fillLightIntensity',
        label: 'Fill Light',
        help: 'Adjust the secondary light that softens shadows and reveals darker areas of the 3D product preview.',
        placeholder: 'Fill Light',
        type: 'Range',
        defaultValue: 0.05,
        itemOptions: {
            min: 0,
            step: 0.01,
            max: 5
        },
        classNames: {container: 'col-span-12 '},
    },
    {
        name: 'engravingTintIntensity',
        label: 'Engraving Tint Light',
        help: 'Adjust the lightness of the engraving overlay shown on the 3D product preview.',
        placeholder: 'Engraving Tint Light',
        type: 'Range',
        defaultValue: 0.5,
        itemOptions: {
            min: 0,
            step: 0.01,
            max: 1
        },
        classNames: {container: 'col-span-12 '},
    },





]

export default Items;
